import { DiffEditor } from '@monaco-editor/react';
import { IDiffEditorProps } from './entities';

export default function BCDiffEditor(props: IDiffEditorProps) {
	return (
		<DiffEditor
			original={props.original}
			language={props.language}
			theme={props.theme}
			width={props.width}
			height={props.height}
			options={{
				selectOnLineNumbers: true,
				roundedSelection: false,
				readOnly: true,
				cursorStyle: 'line',
				automaticLayout: true,
				folding: true,
				fixedOverflowWidgets: false,
				...props.options
			}}
			beforeMount={props.beforeMount}
			onMount={props.onMount}
		/>
	);
}
